export default {
  namespaced: true,
  state: {
    area: 0,
    centroide: null,
    currentGeoFeature: {
      type: 'FeatureCollection',
      features: [
        {
          type: 'Feature',
          properties: {},
          geometry: {
            type: 'Polygon',
            coordinates: [],
          },
        },
      ],
    },
    featureInfoSigpac: {},
    sigpacMap: '',
  },
  getters: {
    viewCentroide(state) {
      if (state.centroide === null) {
        return { lat: 0, lng: 0 };
      }
      return state.centroide;
    },
  },
  actions: {
    setLocation({ commit }, {
      newCoordinates,
      index,
      area,
      centroide,
    }) {
      commit('setArea', area);
      commit('setCentroide', centroide);
      commit('setCurrentGeoFeature', { newCoordinates, index });
    },
    setCurrentGeoFeature(context, { newCoordinates, index }) {
      context.commit('setCurrentGeoFeature', { newCoordinates, index });
    },
    resetCurrentGeoFeature({ commit }) {
      commit('resetCurrentGeoFeature');
    },
    resetAll({ commit }) {
      commit('resetCurrentGeoFeature');
      commit('resetArea');
      commit('resetCentroide');
    },
    resetCentroide({ commit }) {
      commit('resetCentroide');
      commit('resetArea');
    },
    async fetchFeatureInfoSigpac({ commit }, url) {
      try {
        const requestOptions = {
          method: 'GET',
          redirect: 'follow',
        };

        await fetch(url, requestOptions)
          .then((response) => response.json())
          .then((result) => {
            commit('setFeatureInfoSigpac', result);
          })
          .catch((error) => Promise.reject(error));
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error); // Esta llamada no tiene los mensajes de error normalizados
      }
    },
    async fetchSigpacMap({ commit }, url) {
      try {
        const requestOptions = {
          method: 'GET',
          redirect: 'follow',
        };

        await fetch(url, requestOptions)
          .then((response) => {
            commit('setSigpacMap', response);
          })
          .catch((error) => Promise.reject(error));
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error); // Esta llamada no tiene los mensajes de error normalizados
      }
    },
    setCentroide({ commit }, centroide) {
      commit('setCentroide', centroide);
    },
    setArea({ commit }, area) {
      commit('setArea', area);
    },
  },
  mutations: {
    setArea(state, newArea) {
      state.area = newArea;
    },
    setCentroide(state, newCentroide) {
      state.centroide = newCentroide;
    },
    setCurrentGeoFeature(state, { newCoordinates, index }) {
      state.currentGeoFeature.features[index].geometry.coordinates = newCoordinates;
    },
    resetCurrentGeoFeature(state) {
      state.currentGeoFeature = {
        type: 'FeatureCollection',
        features: [
          {
            type: 'Feature',
            properties: {},
            geometry: {
              type: 'Polygon',
              coordinates: [],
            },
          },
        ],
      };
    },
    resetArea(state) {
      state.area = 0;
    },
    resetCentroide(state) {
      state.centroide = null;
    },
    setFeatureInfoSigpac(state, newFeatureInfoSigpac) {
      state.featureInfoSigpac = newFeatureInfoSigpac;
    },
    setSigpacMap(state, newSigpacMap) {
      state.sigpacMap = newSigpacMap;
    },
  },
};
